import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import date from "date-and-time";
import Card from "../shared/Card/Card";
import PriceFormat from "../../utils/priceFormat";
import { IEnginesWorldwide, OfferType } from "../../models/EnginesWorldwide";

export default function EnginesWorldwideDetails({ offer }: { offer?: IEnginesWorldwide }) {
  const { t } = useTranslation("vehicles");

  useEffect(() => {

  }, [offer])

  let pickedUpDate = offer ? new Date(offer.pickedUp) : undefined;

  if (pickedUpDate && pickedUpDate.getFullYear() === 1) {
    pickedUpDate = undefined;
  }

  return (

    <>
      <Card title={t("Engines Worldwide Offer - {{type}}", { type: offer ? OfferType[offer.type].toUpperCase() : "" })} bodyClassName="p-4" collapsible>
        <dl className="divide-y divide-gray-200">
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Offer Id")}</dt>
            <dd className="text-sm text-gray-900 col-span-2">
              {offer?.enginesWorldwideId}
            </dd>
          </div>
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Status")}</dt>
            <dd className="flex justify-between items-center text-sm text-gray-900 col-span-2">
              <div>{offer?.status}</div>
            </dd>
          </div>
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Price")}</dt>
            <dd className="flex justify-between items-center text-sm text-gray-900 col-span-2">
              <div>{offer?.price ?
                PriceFormat(parseFloat(offer?.price))
                : t("N/A")
              }</div>
            </dd>
          </div>
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Media Recieved")}</dt>
            <dd className="text-sm text-gray-900 col-span-2">
              {offer?.mediaReceived ? t("Yes") : t("No")}
            </dd>
          </div>
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Offered")}</dt>
            <dd className="text-sm text-gray-900 col-span-2">
              {offer ? `${date.format(new Date(offer.offered), "DD/MM/YYYY")}` : ""}
            </dd>
          </div>
          <div className="py-2 grid grid-cols-3 gap-4">
            <dt className="text-sm font-medium text-gray-500">{t("Picked Up")}</dt>
            <dd className="text-sm text-gray-900 col-span-2">
              {pickedUpDate ? `${date.format(pickedUpDate, "DD/MM/YYYY")}` : t("Not Picked Up")}
            </dd>
          </div>
        </dl>
      </Card>
    </>
  );
}
